import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import { ServiceIcon } from 'components/common/ServiceIcon'
import ArrowIconFullBrightRedRight from 'components/common/Icon/assets/arrow-icon-full-bright-red-right.svg'

const ServiceTile = ({
  iconName,
  title,
  description,
  url,
  categoryId,
  navigationHandler
}) =>
  <Wrapper>
    <IconWrapper>
      <ServiceIcon
        iconName={ iconName }
        condition
        width={ 50 }
        height={ 50 } />
    </IconWrapper>
    <div>
      <Title to={ url } preventScrollReset onClick={ (e) => navigationHandler(e, categoryId) }>{ title }</Title>
      <Description>{ description }</Description>
    </div>
  </Wrapper>

export default ServiceTile

ServiceTile.propTypes = {
  categoryId: PropTypes.string,
  description: PropTypes.string,
  iconName: PropTypes.string,
  navigationHandler: PropTypes.func,
  title: PropTypes.string,
  url: PropTypes.string
}

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 15px;
`

const IconWrapper = styled.div`
  ${Mixin.responsive('margin-right', '25px', '13px')}
`

const Title = styled(Link)`
  ${Mixin.font.GothamBold(17, 600)}
  color: ${Theme.colors.black};

  &::after {
    content: '';
    background-image: url(${ArrowIconFullBrightRedRight});
    display: inline-block;
    background-repeat: no-repeat;
    background-size: contain;
    height: 15px;
    width: 5px;
    margin-left: 5px;
    position: relative;
    top: 5px;
  }
`

const Description = styled.p`
  ${Mixin.font.GothamBook(14, 400, 18)}
  margin-top: 10px;
  ${Media.mobile`
    margin-top: 5px;
    line-height: 22px;
  `}
`
